class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    // document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    // document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.querySelector("cart-drawer");

  // Whenever cart updates, load recommendations
  document.addEventListener("cart:updated", async (event) => {
    const cart = event.detail.cart;
    if (cart.items.length) {
      const firstProductId = cart.items[0].product_id;
      const products = await fetchCartRecommendations(firstProductId);
      renderRecommendations(products);
    }
  });

  // Fetch Shopify Recommendations
  async function fetchCartRecommendations(productId, limit = 4) {
    const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`);
    const data = await res.json();
    return data.products;
  }

  // Render Recommendations in Drawer
  function renderRecommendations(products) {
    const container = document.getElementById("cart-recommendations-container");
    if (!container) return;

    container.innerHTML = products.map(product => `
      <div class="recommendation-item">
        <div class="rec-image">
          <img src="${product.images[0]?.src}" alt="${product.title}" width="120" height="120" />
        </div>
        <div class="rec-details">
          <h4>${product.title}</h4>
          <p>${Shopify.formatMoney(product.price)}</p>
          ${product.variants.length === 1
            ? `<button class="rec-add-btn button button--small" data-variant="${product.variants[0].id}">Add to Cart</button>`
            : `<button class="rec-choose-btn button button--small" data-handle="${product.handle}">Choose Options</button>`
          }
        </div>
      </div>
    `).join("");
  }

  // AJAX Add to Cart
  document.addEventListener("click", async (e) => {
    if (e.target.classList.contains("rec-add-btn")) {
      const variantId = e.target.dataset.variant;

      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      cartDrawer.fetchCart();
    }
  });

  // Quick Add Modal (reuses Dawn's quick-add.js)
  document.addEventListener("click", async (e) => {
    if (e.target.classList.contains("rec-choose-btn")) {
      const handle = e.target.dataset.handle;

      const res = await fetch(`/products/${handle}?view=quick-add`);
      const html = await res.text();

      // Remove old modal
      document.querySelectorAll("quick-add-modal").forEach(el => el.remove());

      // Insert new modal
      const wrapper = document.createElement("div");
      wrapper.innerHTML = html;
      document.body.appendChild(wrapper.firstElementChild);

      // Trigger Dawn's modal
      const modal = document.querySelector("quick-add-modal");
      if (modal) modal.show();
    }
  });
});
